export default __webpack_public_path__ + "assets/0c183f387db14e15cf88f35e8626b8f3.png";